import image1 from './Joker.webp';
import image2 from './Greedy_Joker.webp';
import image3 from './Lusty_Joker.webp';
import image4 from './Wrathful_Joker.webp';
import image5 from './Gluttonous_Joker.webp';
import image6 from './Jolly_Joker.webp';
import image7 from './Zany_Joker.webp';
import image8 from './Crazy_Joker.webp';
import image9 from './Mad_Joker.webp';
import image10 from './Droll_Joker.webp';
import image11 from './Sly_Joker.webp';
import image12 from './Wily_Joker.webp';
import image13 from './Clever_Joker.webp';
import image14 from './Devious_Joker.webp';
import image15 from './Crafty_Joker.webp';
import image16 from './Half_Joker.webp';
import image17 from './Joker_Stencil.webp';
import image18 from './Four_Fingers.webp';
import image19 from './Mime.webp';
import image20 from './Credit_Card.webp';
import image21 from './Ceremonial_Dagger.webp';
import image22 from './Banner.webp';
import image23 from './Mystic_Summit.webp';
import image24 from './Marble_Joker.webp';
import image25 from './Loyalty_Card.webp';
import image26 from './8_Ball.webp';
import image27 from './Misprint.webp';
import image28 from './Dusk.webp';
import image29 from './Raised_Fist.webp';
import image30 from './Chaos_the_Clown.webp';
import image31 from './Fibonacci.webp';
import image32 from './Steel_Joker.webp';
import image33 from './Scary_Face.webp';
import image34 from './Abstract_Joker.webp';
import image35 from './Delayed_Gratification.webp';
import image36 from './Hack.webp';
import image37 from './Pareidolia.webp';
import image38 from './Gros_Michel.webp';
import image39 from './Even_Steven.webp';
import image40 from './Odd_Todd.webp';
import image41 from './Scholar.webp';
import image42 from './Business_Card.webp';
import image43 from './Supernova.webp';
import image44 from './Ride_the_Bus.webp';
import image45 from './Space_Joker.webp';
import image46 from './Egg.webp';
import image47 from './Burglar.webp';
import image48 from './Blackboard.webp';
import image49 from './Runner.webp';
import image50 from './Ice_Cream.webp';
import image51 from './DNA.webp';
import image52 from './Splash.webp';
import image53 from './Blue_Joker.webp';
import image54 from './Sixth_Sense.webp';
import image55 from './Constellation.webp';
import image56 from './Hiker.webp';
import image57 from './Faceless_Joker.webp';
import image58 from './Green_Joker.webp';
import image59 from './Superposition.webp';
import image60 from './To_Do_List.webp';
import image61 from './Cavendish.webp';
import image62 from './Card_Sharp.webp';
import image63 from './Red_Card.webp';
import image64 from './Madness.webp';
import image65 from './Square_Joker.webp';
import image66 from './Seance.webp';
import image67 from './Riff-Raff.webp';
import image68 from './Vampire.webp';
import image69 from './Shortcut.webp';
import image70 from './Hologram.webp';
import image71 from './Vagabond.webp';
import image72 from './Baron.webp';
import image73 from './Cloud_9.webp';
import image74 from './Rocket.webp';
import image75 from './Obelisk.webp';
import image76 from './Midas_Mask.webp';
import image77 from './Luchador.webp';
import image78 from './Photograph.webp';
import image79 from './Gift_Card.webp';
import image80 from './Turtle_Bean.webp';
import image81 from './Erosion.webp';
import image82 from './Reserved_Parking.webp';
import image83 from './Mail-In_Rebate.webp';
import image84 from './To_the_Moon.webp';
import image85 from './Hallucination.webp';
import image86 from './Fortune_Teller.webp';
import image87 from './Juggler.webp';
import image88 from './Drunkard.webp';
import image89 from './Stone_Joker.webp';
import image90 from './Golden_Joker.webp';
import image91 from './Lucky_Cat.webp';
import image92 from './Baseball_Card.webp';
import image93 from './Bull.webp';
import image94 from './Diet_Cola.webp';
import image95 from './Trading_Card.webp';
import image96 from './Flash_Card.webp';
import image97 from './Popcorn.webp';
import image98 from './Spare_Trousers.webp';
import image99 from './Ancient_Joker.webp';
import image100 from './Ramen.webp';
import image101 from './Walkie_Talkie.webp';
import image102 from './Seltzer.webp';
import image103 from './Castle.webp';
import image104 from './Smiley_Face.webp';
import image105 from './Campfire.webp';
import image106 from './Golden_Ticket.webp';
import image107 from './Mr._Bones.webp';
import image108 from './Acrobat.webp';
import image109 from './Sock_and_Buskin.webp';
import image110 from './Swashbuckler.webp';
import image111 from './Troubadour.webp';
import image112 from './Certificate.webp';
import image113 from './Smeared_Joker.webp';
import image114 from './Throwback.webp';
import image115 from './Hanging_Chad.webp';
import image116 from './Rough_Gem.webp';
import image117 from './Bloodstone.webp';
import image118 from './Arrowhead.webp';
import image119 from './Onyx_Agate.webp';
import image120 from './Glass_Joker.webp';
import image121 from './Showman.webp';
import image122 from './Flower_Pot.webp';
import image123 from './Blueprint.webp';
import image124 from './Wee_Joker.webp';
import image125 from './Merry_Andy.webp';
import image126 from './Oops_All_6s.webp';
import image127 from './The_Idol.webp';
import image128 from './Seeing_Double.webp';
import image129 from './Matador.webp';
import image130 from './Hit_the_Road.webp';
import image131 from './The_Duo.webp';
import image132 from './The_Trio.webp';
import image133 from './The_Family.webp';
import image134 from './The_Order.webp';
import image135 from './The_Tribe.webp';
import image136 from './Stuntman.webp';
import image137 from './Invisible_Joker.webp';
import image138 from './Brainstorm.webp';
import image139 from './Satellite.webp';
import image140 from './Shoot_the_Moon.webp';
import image141 from './Driver_License.webp';
import image142 from './Cartomancer.webp';
import image143 from './Astronomer.webp';
import image144 from './Burnt_Joker.webp';
import image145 from './Bootstraps.webp';
import image146 from './Canio.webp';
import image147 from './Triboulet.webp';
import image148 from './Yorick.webp';
import image149 from './Chicot.webp';
import image150 from './Perkeo.webp';

const images = {
  image1: image1,
  image2: image2,
  image3: image3,
  image4: image4,
  image5: image5,
  image6: image6,
  image7: image7,
  image8: image8,
  image9: image9,
  image10: image10,
  image11: image11,
  image12: image12,
  image13: image13,
  image14: image14,
  image15: image15,
  image16: image16,
  image17: image17,
  image18: image18,
  image19: image19,
  image20: image20,
  image21: image21,
  image22: image22,
  image23: image23,
  image24: image24,
  image25: image25,
  image26: image26,
  image27: image27,
  image28: image28,
  image29: image29,
  image30: image30,
  image31: image31,
  image32: image32,
  image33: image33,
  image34: image34,
  image35: image35,
  image36: image36,
  image37: image37,
  image38: image38,
  image39: image39,
  image40: image40,
  image41: image41,
  image42: image42,
  image43: image43,
  image44: image44,
  image45: image45,
  image46: image46,
  image47: image47,
  image48: image48,
  image49: image49,
  image50: image50,
  image51: image51,
  image52: image52,
  image53: image53,
  image54: image54,
  image55: image55,
  image56: image56,
  image57: image57,
  image58: image58,
  image59: image59,
  image60: image60,
  image61: image61,
  image62: image62,
  image63: image63,
  image64: image64,
  image65: image65,
  image66: image66,
  image67: image67,
  image68: image68,
  image69: image69,
  image70: image70,
  image71: image71,
  image72: image72,
  image73: image73,
  image74: image74,
  image75: image75,
  image76: image76,
  image77: image77,
  image78: image78,
  image79: image79,
  image80: image80,
  image81: image81,
  image82: image82,
  image83: image83,
  image84: image84,
  image85: image85,
  image86: image86,
  image87: image87,
  image88: image88,
  image89: image89,
  image90: image90,
  image91: image91,
  image92: image92,
  image93: image93,
  image94: image94,
  image95: image95,
  image96: image96,
  image97: image97,
  image98: image98,
  image99: image99,
  image100: image100,
  image101: image101,
  image102: image102,
  image103: image103,
  image104: image104,
  image105: image105,
  image106: image106,
  image107: image107,
  image108: image108,
  image109: image109,
  image110: image110,
  image111: image111,
  image112: image112,
  image113: image113,
  image114: image114,
  image115: image115,
  image116: image116,
  image117: image117,
  image118: image118,
  image119: image119,
  image120: image120,
  image121: image121,
  image122: image122,
  imageBlueprint: image123,
  image124: image124,
  image125: image125,
  image126: image126,
  image127: image127,
  image128: image128,
  image129: image129,
  image130: image130,
  image131: image131,
  image132: image132,
  image133: image133,
  image134: image134,
  image135: image135,
  image136: image136,
  image137: image137,
  image138: image138,
  image139: image139,
  image140: image140,
  image141: image141,
  image142: image142,
  image143: image143,
  image144: image144,
  image145: image145,
  image146: image146,
  image147: image147,
  image148: image148,
  image149: image149,
  image150: image150,
};

export default images;